<template>
  <div class="EmptyState">
    <FAIcon
      v-if="icon"
      class="empty-state-icon"
      :icon="icon"
      size="2x"
    />
    <p class="empty-state-message">
      {{ message }}
    </p>
    <div
      v-if="$slots.default"
      class="empty-state-action"
    >
      <slot />
    </div>
  </div>
</template>

<script src="./empty_state.js"></script>

<style lang="scss">
.EmptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75em;
  padding: 2em 1em;
  text-align: center;
  color: var(--textFaint, var(--text));

  .empty-state-icon {
    color: var(--icon, var(--textFaint));
  }

  .empty-state-message {
    margin: 0;
    max-width: 40ch;
    line-height: 1.5;
  }

  .empty-state-action > .button-default {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 2em;
    line-height: 2em;
    padding: 0 0.75em;
  }
}
</style>
